import styled from 'styled-components'

export const DoubleBox = styled.div<{ $standalone?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 1rem;
  height: ${({ $standalone }) => ($standalone ? 'calc(100vh - 12rem)' : 'calc(100% - 240px)')};
  min-height: 0;
  overflow: hidden;
  margin-top: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    height: auto;
    overflow: visible;
  }
`
